import { Box, MenuItem } from '@mui/material';
import { Add as AddIcon, Download } from '@mui/icons-material';

import {
  CustomAutoComplete,
  CustomButton,
  CustomTextField,
  HorizontalForm,
} from '../../../common/components';
import { downloadSupplierLedgerExport } from '../../../hooks/useSupplierLedger';
import {
  ACCOUNTING_SOURCE_OPTIONS,
  ACCOUNTING_STATUS_OPTIONS,
} from '../constants/accountingEntriesConstants';

const AccountingEntriesToolbar = ({
  filters,
  onFilterChange,
  onCreate,
}) => (
  <Box sx={{ backgroundColor: 'background.paper', borderBottom: '1px solid #ccc' }}>
    <HorizontalForm withBorder={false} sx={{ px: 2.5, py: 2, gap: 1.5, alignItems: 'center', flexWrap: 'wrap' }}>
      <CustomButton variant="base" startIcon={<AddIcon />} onClick={onCreate}>
        Nuevo asiento
      </CustomButton>
      <CustomButton variant="outlined" startIcon={<Download />} onClick={() => downloadSupplierLedgerExport('accounting_entries')}>
        Asientos Excel
      </CustomButton>
      <CustomAutoComplete
        label="Origen"
        name="source_type"
        value={filters.source_type}
        onChange={onFilterChange}
        sx={{ width: 220 }}
      >
        {ACCOUNTING_SOURCE_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </CustomAutoComplete>
      <CustomAutoComplete
        label="Estado"
        name="status"
        value={filters.status}
        onChange={onFilterChange}
        sx={{ width: 180 }}
      >
        {ACCOUNTING_STATUS_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </CustomAutoComplete>
      <CustomTextField
        label="Desde"
        type="date"
        name="start_date"
        value={filters.start_date}
        onChange={onFilterChange}
        shrinkLabel
        sx={{ width: 170 }}
      />
      <CustomTextField
        label="Hasta"
        type="date"
        name="end_date"
        value={filters.end_date}
        onChange={onFilterChange}
        shrinkLabel
        sx={{ width: 170 }}
      />
    </HorizontalForm>
  </Box>
);

export default AccountingEntriesToolbar;
